import React from 'react';
import PropTypes from 'prop-types';

// Styled.
import * as S from './styled';

/**
 * A simple button that can be used for links.
 *
 * @param {*} children the content to render (or false).
 * @param {Object} buttonProps The props passed to the button.
 *
 * @returns {Element} The rendered button.
 */
const ButtonLink = ({ children = false, ...buttonProps }) => (
  <S.Button type="button" {...buttonProps}>
    {children}
  </S.Button>
);

ButtonLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.string])),
  ]),
};

export default ButtonLink;
